<div class="wrapper">
  <div class="form-container">
    <app-default-form
      [mode]="'new'"
      (aisProductChanged)="onAisProductChanged($event)"></app-default-form>
  </div>
  <mat-divider></mat-divider>
  <div class="actions">
    <button
      [disabled]="!formValid()"
      (click)="save()"
      mat-flat-button
      color="primary">
      Save
    </button>
  </div>
</div>
